import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IOption } from '../button-radio-group/button-radio-group-option.model';

@Component({
  selector: 'kh-button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrls: ['./button-toggle.component.less'],
  standalone: false
})
export class ButtonToggleComponent implements OnInit {
  @Input()
  public trueLabel?: string;

  @Input()
  public falseLabel?: string;

  @Input()
  public value = false;

  @Output()
  public valueChange = new EventEmitter<boolean>();

  public options?: IOption[];

  public ngOnInit(): void {
    this.options = [
      {
        label: this.trueLabel || '',
        value: true
      },
      {
        label: this.falseLabel || '',
        value: false
      }
    ];
  }

  public notifyChanged(): void {
    this.valueChange.next(this.value);
  }
}
